import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import SelectFieldMateriasComponent from '../../../materias/components/SelectFieldMaterias';
import {
  asignarMateriasDocentesAction,
  deleteMateriasDocentesAction,
} from '../../DocentesAction';

const MateriasDocentesComponent = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const docentesStore = Redux.useSelector((state) => state.docentes);

  const materias = docentesStore.activo.materias;

  const [idMateria, setIdMateria] = React.useState('');
  const [loadingDelete, setLoadingDelete] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <LoadingWidget
        isLoading={docentesStore.loadingAll || loadingDelete}
        text={
          loadingDelete ? 'Eliminando asignacion...' : 'Asignando materia...'
        }
      />

      <Grid item md={8}>
        <SelectFieldMateriasComponent
          value={idMateria}
          isAll={false}
          onChange={(idMateria) => setIdMateria(idMateria)}
          selects={materias}
        />
      </Grid>

      <Grid item md={3} sx={{ display: 'flex' }}>
        <BotonComponent
          click={async () => {
            const res = await asignarMateriasDocentesAction(
              { dispatch, notify },
              {
                idDocente: docentesStore.activo.id,
                idMateria,
              },
            );
            if (res) setIdMateria('');
          }}
          text="ASIGNAR"
          disabled={!idMateria}
          addIcon
          green
          mr={2}
        />
      </Grid>

      <Grid item md={12}>
        <Divider sx={{ my: 1 }} />
        <Typography variant="h5" color="initial">
          Asignados
        </Typography>
        <TableContainer>
          <Table size="small" aria-label="materias">
            <TableHead>
              <TableRow>
                {loginStore.isRoot ? <TableCell>ID</TableCell> : null}
                <TableCell>Materia</TableCell>
                <TableCell>Descripción</TableCell>
                <TableCell>Acción</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {materias.map((el) => (
                <TableRow
                  key={el.materia.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  {loginStore.isRoot ? (
                    <TableCell>{el.materia.id}</TableCell>
                  ) : null}
                  <TableCell>{el.materia.nombre}</TableCell>
                  <TableCell>{el.materia.desc}</TableCell>
                  <TableCell>
                    <Tooltip
                      describeChild
                      title="Eliminar seccion"
                      placement="top"
                    >
                      <IconButton
                        color="error"
                        size="small"
                        aria-label="Eliminar seccion"
                        onClick={async () => {
                          setLoadingDelete(true);
                          await deleteMateriasDocentesAction(
                            { dispatch, notify },
                            docentesStore.activo.id,
                            el.materia.id,
                          );
                          setLoadingDelete(false);
                        }}
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};

export default MateriasDocentesComponent;
